<template>
  <div class="media">
    <img v-if="brand" :src="brand.goorder_logo" alt="" />
    <div class="media-body">
      <div class="food-dine-content">
        <template v-if="order">
          <div class="media">
            <div class="media-body">
              <!-- <h6>{{ _T('FAST FOOD') }}</h6> -->
              <h3>{{ _T_DB(store, 'name') }}</h3>
            </div>
            <span :class="getOrderBadge(order)">
              {{ getOrderStatus(order) }}
            </span>
          </div>
          <ul class="delivery-list">
            <li>
              <h6>{{ _T('Order') + ' ' }}#</h6>
              <h5>{{ order.order_no }}</h5>
            </li>
            <li>
              <h6>{{ _T('Date &amp; Time') }}</h6>
              <h5>
                {{ orderDate(order.real_created_datetime) }}
              </h5>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as utils from '@/utils/main_utils'

export default {
  name: 'HistoryCommonHeader',
  props: {
    order: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'find_store_by_main_id',
      'find_brand_by_main_id',
    ]),
    store() {
      if (this.order) {
        return this.find_store_by_main_id(this.order.store_id)
      }
      return ''
    },
    brand() {
      if (this.order) {
        return this.find_brand_by_main_id(this.order.brand_id)
      }
      return ''
    },
  },
  methods: {
    orderDate(date) {
      if (date) {
        return utils.datetime_in_local_timezone(date)
      }
    },
    orderStatus(order_status) {
      if (order_status) {
        return order_status.replace(/-/g, ' ').toUpperCase()
      }
      return order_status
    },
    getOrderBadge(order) {
      return this.orderBagde(this.getOrderStatus(order))
    },
    getOrderStatus(order) {
      if (!order || !order.order_status) {
        return ''
      }
      return order.order_status === this.CONST.ORDER_STATUS_IN_PROGRESS &&
        order.order_system_status === this.CONST.ORDER_SYSTEM_STATUS_REJECTED
        ? 'CANCELLED'
        : order.order_status.toUpperCase()
    },
    orderBagde(orderStatus) {
      switch (orderStatus) {
        case 'BOOKING COMPLETE':
        case 'FINISHED':
          return 'badge-process'
        case 'PICKED UP':
        case 'IN-PROGRESS':
          return 'badge-delayed'
        case 'CANCELLED':
        case 'READY':
          return 'badge-cancle'
        default:
          return 'badge-delivered'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.account-card {
  .account-header {
    border-bottom: $px1 solid $dark-border;
    padding: $px16 $px50;

    h4 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
}
.media {
  .media-body {
    .food-dine-content {
      padding-left: $px20;

      .media {
        .media-body {
          > h6 {
            font-weight: 600;
            line-height: $px22;
            letter-spacing: 0.005em;
            color: $light-font;
            margin-bottom: 0;
          }
          h3 {
            font-weight: bold;
            margin-bottom: $px20;
          }
        }
        span {
          padding: $px10 $px10 $px8;
          width: $px160;
          border-radius: $px4;
          font-weight: 600;
          line-height: $px22;
          letter-spacing: 0.005em;
          text-align: center;
        }
        .badge-delivered,
        .delivered-title {
          background-color: $color-tertiary-1;
          color: $color-tertiary;
        }

        .badge-delayed,
        .carry-title {
          background-color: $warning-color-background;
          color: $warning-color;
        }

        .badge-cancle {
          background-color: $color-primary-1;
          color: $color-primary;
        }

        .badge-process,
        .dining-title {
          background-color: $color-secondary-1 !important;
          color: $color-secondary !important;
        }

        .badge-process,
        .dining-title {
          background-color: var(--secondary-color-1);
          color: $color-secondary;
        }
      }

      ul {
        margin-bottom: $px24;

        li {
          + li {
            margin-left: calc(
              #{$px20} + (90 - 20) * ((100vw - #{$px320}) / (1920 - 320))
            );
          }

          img {
            width: $px20;
          }

          h5 {
            font-weight: 600;
            margin: $px12 0 0;
          }

          h6 {
            font-weight: normal;
            font-size: $px12;
            line-height: $px15;
            color: $font-color;
            margin-bottom: 0;
          }
        }
      }

      .delivery-list {
        li {
          padding: 0 $px15 0 $px18;

          &:first-child {
            padding-left: 0;
          }

          h5 {
            margin: $px5 0 0;

            span {
              font-weight: 400;
            }
          }

          + li {
            margin-left: 0;
            border-left: $px1 solid $light-border;
          }
        }
      }
    }
  }

  .waiting-conformation {
    border: $px2 solid $color-primary;
    padding: $px8 $px20;
    border-radius: $px50;

    span {
      + span {
        vertical-align: middle;
        font-weight: 600;
        font-size: calc(
          #{$px14} + (20 - 14) * ((100vw - #{$px320}) / (1920 - 320))
        );
        line-height: $px30;
        color: $black;
        margin-left: $px10;
      }
    }
  }

  &.logo-size {
    > img {
      width: $px64;
      border-radius: 100%;
    }
  }
}
@media (max-width: 991px) {
  .media {
    .media-body {
      .food-dine-content {
        .media {
          display: block;
        }
        ul {
          li {
            h5 {
              font-size: $px14;
            }
          }
        }
      }
      ul {
        margin-top: $px24;
        display: flex;
        li {
          margin-left: 0 !important;
          + li {
            padding-left: $px12;
          }
        }
      }
    }
    .waiting-conformation {
      display: inline-block;
    }
  }
}
@media (max-width: 575px) {
  .media {
    display: block;
    img {
      display: flex;
      border-radius: 100%;
      margin-left: auto;
      margin-right: auto;
      width: 10rem;
      height: auto;
    }
    .media-body {
      .food-dine-content {
        .media {
          margin-top: $px12;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
